import React from 'react';

const IndexHowWeWork = () => (
  <section className="pb-lg-9 pb-7">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-md-6 mb-6 mb-lg-0">
          <div className="position-relative about-shape">
            <img className="img-fluid" src="images/about/about-01.jpg" alt="about" />
            <div className="position-absolute bottom left right">
              <img className="svg-injector w-100" src="images/svg/shape-03.svg" alt="svg" />
            </div>
          </div>

          <div className="p-4 bg-white shadow-lg position-absolute top right text-center border-radius-lg mt-6 mr-lg-n8 mr-5 mr-md-0">
            <h5 className="font-weight-normal mb-1">Project success rate</h5>
            <h2 className="mb-0 h1 font-weight-normal">100%</h2>
            <div className="progress mt-3 mb-0" style={{ height: '5px' }}>
              <div
                className="progress-bar"
                role="progressbar"
                style={{ width: '100%' }}
                aria-valuenow="90"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </div>
        </div>

        <div className="col-xl-5 offset-md-1 col-md-5">
          <div className="mb-md-6 mb-5">
            <h2 className="font-weight-normal mb-2">How we work</h2>
            <p className="mb-0">
              We are using waterfalls, and agile methodologies. This methodology allows requirements to evolve via a cross-functional
              approach, which gives clients better control of how the project is handled/managed and effected/executed.
            </p>
          </div>

          <ol className="list-unstyled mb-0">
            <li className="mr-2 mb-3">
              <b>Phase 1 - </b> High level estimation, ask for a free quote
            </li>
            <li className="mr-2 mb-3">
              <b>Phase 2 - </b> Detail requirement study, statement of work signed
            </li>
            <li className="mr-2 mb-3">
              <b>Phase 3 - </b> Frontend / backend design and development
            </li>
            <li className="mr-2 mb-3">
              <b>Phase 4 - </b>User acceptance test
            </li>
            <li className="mr-2">
              <b>Phase 5 - </b>Launch, support and continually enhancement
            </li>
          </ol>
        </div>
      </div>
    </div>
  </section>
);

export default IndexHowWeWork;
